/** BookingStatusSelect — the status filter at desktop, where the chips would
 *  crowd the toolbar. The card-breakpoint equivalent is `BookingStatusChips`. */
import { CONTROL, STATUS_OPTIONS, type StatusValue } from './bookingFilterOptions';

export function BookingStatusSelect({
  status,
  onStatusChange,
}: {
  status: StatusValue;
  onStatusChange: (v: StatusValue) => void;
}) {
  return (
    <label className="flex items-center gap-2 text-sm text-stone-600 dark:text-stone-400">
      <span className="text-xs font-semibold uppercase tracking-wide text-stone-500">Status</span>
      <select
        aria-label="Filter by status"
        value={status}
        onChange={(e) => onStatusChange(e.target.value as StatusValue)}
        className={CONTROL}
      >
        {STATUS_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
